<div class="bg-m0 flex select-none flex-col p-9">
  <div
    data-cy="addProjectRoleDialogTitle"
    class="text-s2 mt-5 flex-grow text-left text-2xl font-semibold"
    >Add Role</div
  >

  <form
    class="flex w-[520px] flex-col"
    [formGroup]="addProjectRoleForm"
    (ngSubmit)="add()"
  >
    <div class="mt-9 flex flex-row items-start">
      <div class="mt-3 w-[120px] flex-shrink-0 text-base font-semibold"
        >Name</div
      >

      <div class="flex w-[320px] flex-col">
        <input
          #roleId
          autocomplete="off"
          spellcheck="false"
          data-cy="addProjectRoleDialogRoleIdInput"
          class="form-input border-s3 focus:border-m600 rounded"
          [ngClass]="{
            'border-r600':
              addProjectRoleForm.controls['roleId'].invalid &&
              addProjectRoleForm.controls['roleId'].touched
          }"
          formControlName="roleId"
        />
        <m-validation
          [control]="addProjectRoleForm.controls['roleId']"
        ></m-validation>
      </div>
    </div>

    <div class="mt-6">
      <button
        data-cy="addProjectRoleDialogAddButton"
        class="bg-m600 text-m0 w-28 rounded py-3 text-base font-medium focus:outline-none"
        type="submit"
        >Add</button
      >

      <button
        data-cy="addProjectRoleDialogCancelButton"
        class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
        type="button"
        (click)="cancel()"
        >Cancel</button
      >
    </div>
  </form>
</div>
